import { render, staticRenderFns } from "./ybRecordLog.vue?vue&type=template&id=77b655c4&scoped=true"
import script from "./ybRecordLog.vue?vue&type=script&lang=js"
export * from "./ybRecordLog.vue?vue&type=script&lang=js"
import style0 from "./ybRecordLog.vue?vue&type=style&index=0&id=77b655c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b655c4",
  null
  
)

export default component.exports